import { SelectTrainingComponent } from 'modules/trainings/components/CatalogComponent/SelectTrainingComponent'

const SelectTraining = () => <SelectTrainingComponent />

export default SelectTraining
